import React from 'react';
import { ErrorAppearance, ErrorMessageWrapper } from 'wix-ui-tpa/cssVars';
import { classes } from './field-error-wut.st.css';
import { getErrorDataHook } from '../../services/field-attributes';
export const FieldErrorWUT = _ref => {
  let {
    target,
    hasError,
    errorMessage,
    id
  } = _ref;
  return /*#__PURE__*/React.createElement(ErrorMessageWrapper, {
    className: classes.root,
    visible: Boolean(hasError),
    message: errorMessage ?? '',
    "data-hook": getErrorDataHook(target),
    messageId: id,
    errorAppearance: ErrorAppearance.TextOnly
  });
};
//# sourceMappingURL=field-error-wut.js.map